function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Link } from "./library/link";
import { Teasers, SliderTeaser } from "./teaser";
import Slider from "react-slick";
import { slugify } from "../../../Shared/utils/string";
export class CarouselContentGridBlock extends React.Component {
    componentDidMount() {
        this.mediaquery.addListener(this.handleResize);
    }
    componentWillUnmount() {
        this.mediaquery.removeListener(this.handleResize);
    }
    render() {
        const p = this.props;
        const teaserprops = p.items.map((i, k)=>({
                extraClasses: 'block__item',
                headingLevel: p.title && p.title != "" ? 'h3' : 'h2',
                title: i.title,
                linkUrl: i.linkUrl,
                intro: i.subtitle,
                label: i.label,
                imageUrl: i.imageUrl,
                imageUrlFallback: i.imageUrlFallback,
                imageAlt: i.imageAlt,
                video: i.video
            })).toList();
        return /*#__PURE__*/ _jsx("section", {
            className: "block block--content-grid-carousel",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "block__inner container-fluid 22",
                children: [
                    p.title && p.title != "" && /*#__PURE__*/ _jsx("header", {
                        className: "block__header",
                        children: /*#__PURE__*/ _jsx("h2", {
                            className: "block__title title--l",
                            children: p.title
                        })
                    }),
                    this.state.mobile ? /*#__PURE__*/ _jsx(Slider, {
                        accessibility: true,
                        dots: true,
                        arrows: false,
                        infinite: false,
                        className: "center",
                        centerMode: true,
                        centerPadding: "0",
                        speed: 500,
                        slidesToShow: 1.5,
                        slidesToScroll: 1,
                        swipeToSlide: true,
                        dotsClass: "slick-dots",
                        onReInit: ()=>{
                            const slides = document.querySelectorAll('.slick-slide');
                            slides.forEach((slide)=>{
                                slide.setAttribute('aria-hidden', 'false');
                            });
                            const dots = document.querySelectorAll('.slick-dots li');
                            if (dots == null || dots.length == 0) {
                                return;
                            }
                            dots.forEach((dot, key)=>{
                                if (dot.classList.contains('slick-active')) {
                                    dot.setAttribute('aria-current', 'true');
                                } else {
                                    dot.removeAttribute('aria-current');
                                }
                            });
                        },
                        customPaging: (i)=>/*#__PURE__*/ _jsxs("button", {
                                tabIndex: -1,
                                children: [
                                    /*#__PURE__*/ _jsxs("span", {
                                        className: "sr-txt",
                                        children: [
                                            "Navigeer naar item ",
                                            i + 1,
                                            " van ",
                                            teaserprops.size
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        "aria-hidden": "true",
                                        children: i + 1
                                    })
                                ]
                            }),
                        children: teaserprops.map((i)=>/*#__PURE__*/ _jsx(SliderTeaser, {
                                ...i
                            }, `carousel-content-grid-item-${slugify(i.title)}`))
                    }) : /*#__PURE__*/ _jsx(Teasers, {
                        items: teaserprops,
                        row_count: p.row_count
                    }),
                    p.primaryActionTitle && p.primaryActionUrl && /*#__PURE__*/ _jsx(Link, {
                        className: "link grid__button",
                        url: p.primaryActionUrl,
                        children: p.primaryActionTitle
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props), _define_property(this, "mediaquery", window.matchMedia("(max-width: 1024px)")), _define_property(this, "handleResize", (e)=>this.setState((s)=>({
                    ...s,
                    mobile: e.matches
                })));
        this.state = {
            mobile: this.mediaquery.matches
        };
    }
}
